import { useQuery, useMutation, useQueryClient } from "react-query";
import { adminWebauthnApi } from "../api/adminWebauthnApi";

/**
 * Admin: manage a single analyst's credentials and view their login history.
 * Queries are disabled until an analystId is provided (after a lookup).
 */
export function useAdminCredentials(analystId) {
  const qc = useQueryClient();
  const enabled = !!analystId;

  const credentials = useQuery(
    ["webauthn", "admin-credentials", analystId],
    () => adminWebauthnApi.analystCredentials(analystId),
    { enabled }
  );

  const loginHistory = useQuery(
    ["webauthn", "admin-login-history", analystId],
    () => adminWebauthnApi.analystLoginHistory(analystId),
    { enabled }
  );

  const invalidate = () =>
    qc.invalidateQueries(["webauthn", "admin-credentials", analystId]);

  const disable = useMutation((id) => adminWebauthnApi.disableCredential(id), {
    onSuccess: invalidate,
  });
  const remove = useMutation((id) => adminWebauthnApi.deleteCredential(id), {
    onSuccess: invalidate,
  });
  const setExpiry = useMutation(
    ({ id, durationDays }) => adminWebauthnApi.setExpiry(id, durationDays),
    { onSuccess: invalidate }
  );

  return { credentials, loginHistory, disable, remove, setExpiry };
}
